import { BrandCode } from "@typed/common";
import { iconMap, dryTimeMap } from "./icondata";

export interface ITechDataFields {
  name: string;
  value: string;
  icon?: string;
  iconWidth?: string;
  showValueText?: boolean;
}

export const ProcessProductTechData = (product: Queries.ProductTechInfoFragment, brandCode: BrandCode): ITechDataFields[] => {
  const { products_colors: techInfo } = product;
  if (techInfo == null) return [];

  const { granulation, lightfastness_rating, opacity_transparency, staining = "NA", grind = "NA", drytime } = techInfo;

  const safeTransparency = opacity_transparency ?? "NA";
  const safeLightfastness = lightfastness_rating ?? "NA";
  const safeStaining = staining ?? "NA";
  const safeGrind = grind ?? "NA";
  let safeGranulation = "NA";
  if (granulation != null) safeGranulation = granulation ? "G" : "-";

  const safeDrytime = drytime ? dryTimeMap[drytime] : "";

  if (brandCode === "gaa")
    return [
      // { name: "Pigment Classification", value: techInfo?.pigment_classification ?? "" },
      // { name: "Color Index Name", value: techInfo?.color_index_name ?? "" },
      // { name: "Color Index Number", value: techInfo?.color_index_number ?? "" },
      // { name: "Chemical Description", value: techInfo?.chemical_description ?? "" },
      {
        name: "Opacity / Transparency",
        value: iconMap.transparency[safeTransparency.toLowerCase()]?.explanation ?? safeTransparency,
        icon: iconMap.transparency[safeTransparency.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.transparency[safeTransparency.toLowerCase()]?.width ?? null,
        showValueText: true,
      },
      {
        name: "Lightfastness rating",
        value: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.explanation ?? safeLightfastness,
        icon: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.width ?? null,
        showValueText: true,
             },
      // { name: "Permanency", value: techInfo?.permanency ?? "" },
      {
        name: "Munsell Notation Listing",
        value: `Hue:${techInfo?.munsell_hue} ${techInfo?.munsell_hue_suffix ?? ""} Value:${techInfo?.munsell_value} Chroma:${techInfo?.munsell_chroma}`,
      },
      { name: "Gloss Average", value: `${techInfo?.gloss_average}` },

      { name: "Viscosity Range", value: techInfo?.viscosity_range ?? "" },
      { name: "CIE L*a*b* Values", value: ` L*${techInfo?.cie_l} a*${techInfo?.cie_a} b*${techInfo?.cie_b}` },
      { name: "Tint Strength", value: `${techInfo?.tint_strength}` ?? "" },
    ];

  if (brandCode === "wb")
    return [
      // { name: "Color Index Name", value: techInfo?.color_index_name ?? "" },
      // { name: "Color Index Number", value: techInfo?.color_index_number ?? "" },
      // { name: "Pigment Name", value: techInfo?.pigment_name ?? "" },
    
      {
        name: "Opacity / Transparency",
        value: iconMap.transparency[safeTransparency.toLowerCase()]?.explanation ?? safeTransparency,
        icon: iconMap.transparency[safeTransparency.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.transparency[safeTransparency.toLowerCase()]?.width ?? null,
        showValueText: true,
      },
      {
        name: "Lightfastness rating",
        value: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.explanation ?? safeLightfastness,
        icon: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.width ?? null,
        showValueText: true,
      },
      { name: "Drying Time", value: safeDrytime },
      { name: "Grind", 
        value: safeGrind, 
        icon: iconMap.grind[safeGrind.toLowerCase()]?.url ?? null, showValueText: true ,
        iconWidth: iconMap.grind[safeGrind.toLowerCase()]?.width ?? null,
      }
    ];
  if (brandCode === "qor")
{

    return [
      // { name: "Color Index Name", value: techInfo?.color_index_name ?? "" },
      // { name: "Pigment Name", value: techInfo?.pigment_name ?? "" },
      // { name: "Common Name ", value: techInfo?.common_name ?? "" },
      {
        name: "Lightfastness rating",
        value: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.explanation ?? safeLightfastness,
        icon: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.width ?? null,
        showValueText: true,
      },
      {
        name: "Opacity / Transparency",
        value: iconMap.transparency[safeTransparency.toLowerCase()]?.explanation ?? safeTransparency,
        icon: iconMap.transparency[safeTransparency.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.transparency[safeTransparency.toLowerCase()]?.width ?? null,
        showValueText: true,
      },
      { name: "Staining",
        value: safeStaining, 
        icon: (iconMap.staining[safeStaining.toLowerCase()]?.url) ?? null, 
        iconWidth: (iconMap.staining[safeStaining.toLowerCase()]?.width) ?? null  ,
        showValueText: true 
      },
      { name: "Granulation", value: safeGranulation },
    ];
  }
  if (brandCode === "pp")
    return [
      // { name: "Color Index Name", value: techInfo?.color_index_name ?? "" },
      // { name: "Chemical Description", value: techInfo?.chemical_description ?? "" },

      {
        name: "Lightfastness rating",
        value: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.explanation ?? safeLightfastness,
        icon: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.url ?? null,
        iconWidth: iconMap.lightfastness[safeLightfastness.toLowerCase()]?.width ?? null ,
        showValueText: true,
      },
    ];

  return [];
};

export const ProcessNonColorTechData = (product: Queries.NonColorTechInfoFragment): ITechDataFields[] => {
  if (!product.products_noncolor) return [];

  const { opacity_transparency, gloss_average, viscosity_range } = product.products_noncolor;

  const safeTransparency = opacity_transparency ?? "NA";

  return [
    {
      name: "Opacity / Transparency",
      value: safeTransparency,
      icon: iconMap.transparency[safeTransparency.toLowerCase()]?.url ?? null,
      iconWidth:iconMap.transparency[safeTransparency.toLowerCase()].width ?? null,
      showValueText: true,
    },
    { name: "Gloss Average", value: `${gloss_average ?? "?"}` },

    { name: "Viscosity Range", value: viscosity_range ?? "" },
  ];
};
